module.exports = __webpack_public_path__ + "media/images/pic/brodno/teddy-teacher-6546c9dd8dffaab5319c7a2a1f1989fc.webp";